import { useEffect, useState, useContext } from "react";
import { addUserQuery, getUsersListsCntQuery, getUsersListsQuery, updateUserQuery, getUserDetailsQuery, getUserQuery, userActiveQuery, deleteUserQuery, userEmailQuery } from "../../graphql/users_queries";
import { useQuery, useApolloClient } from '@apollo/client';
import { GlobalContext } from '../../hooks/globalContext';
import { exit } from "process";
import { stringify } from 'querystring';
import { sendPasswordResetEmail, submitNewPassword, } from 'supertokens-web-js/recipe/emailpassword';
// import Session from "supertokens-auth-react/lib/build/recipe/session/recipe";
import Session from 'supertokens-web-js/recipe/session';
import AppConfig from "../../utility/AppConfig";
import apiCall from "../../utility/api";
import { getSitesListsFromSiteQuery } from "../../../../api-graphql/src/graphql-queries/v2/home_queries";
import { updateUserStatus } from "../../utility/utils";
import { sendMail } from "../../pages/signin/signin";

interface UserConditions {
	firstName: string;
	lastName: string;
	userEmail: string;
	timeZone: string;
	securityType: string;
	formDataEdit: string;
	role_assigned: string;
	Created_on: string;
	tenant: string

}

type dataProps = {
	[x: string]: any; // since we have not declare formDataEdit we are using this 
	// formDataEdit: any;
	data: any;
	func: any;
	searchVal: any
	pageNo: any
	setTotalPages: any
	setTotalRecords: any
	isFilter?: any
	dropDownValue1?: any
	setIsFilter?: any
	dropDownValue2?: any
	saveUserDetails?: any; // Making it optional
	setSaveUserDetails?: any
	formDataUser: any
	setFormDataUser: any
	deleteUser: any
	setDeleteUser: any
	setDeleteDisabled: any
	setEditUserDetails: any
	editUserDetails: any
	rowId?: any
	setRowID?: any
	handleEditData?: any
	setIsToast?: any
	isRefresh?: any
	setIsRefresh?: any
	setRefreshToast?: any
	setExportDetails?: any
	setdeleteUserToast?: any
	deleteUserToast?: any
	currentSelectedUserFormDetails?: any
	setCurrentSelectedUserFormDetails?: any
	filterArray?: any
	setSiteList?: any
	setRoleList?: any
	setOverlayOpen?: any
	setEmailExistsToast?: any
	setExportBtnClicked?: any;
	exportBtnClicked?: any;
	tenant?: any
	setLoading?: any;
	isApprovalPage?: any;
	setMailSent?: any;
	isMailsent?: any;
	setSpinnerLoad?: any;
}


export const Users_func = (props: dataProps) => {

	const client = useApolloClient();
	const contextValue: any = useContext(GlobalContext);
	const currentTenant = contextValue?.tenantName;
	useEffect(() => {
		getSiteList();
	}, []);

	useEffect(() => {
		getRoles();
	}, []);


	useEffect(() => {

		if (props.deleteUser && contextValue.selectedRowIdInTable.length > 0) {
			deleteUser(contextValue.selectedRowIdInTable);
			// getUsersList(null, 50, parseInt(props.pageNo));
			// getUserListCnt(null);
		}else if (props.saveUserDetails == true) {
			addUser();
			//getUsersList(null, 50, parseInt(props.pageNo));
			//getUserListCnt(null);
			props.setSaveUserDetails(false);
			// props.setFormDataUser(null);
			props.setIsToast(false);
		}else if (props.editUserDetails == true && props.formDataUser !== null) {
			updateUserDetails();
			props.setFormDataUser(null)
			setTimeout(() => {
				props.setRowID(null)
				props.setEditUserDetails(false)
			}, 10000);
		}else if (props?.searchVal?.length > 0 && props.searchVal !== "") {
			if (props.isApprovalPage) {
				getSSOUsersList({ search: props.searchVal, type: 'search' }, 50, parseInt(props.pageNo));
				getSSOUserListCnt({ search: props.searchVal, type: 'search' });
			} else {
				getUsersList({ search: props.searchVal, type: 'search' }, 50, parseInt(props.pageNo));
				getUserListCnt({ search: props.searchVal, type: 'search' });
			}

		} else if (props.isFilter == true) {
			if (props.isApprovalPage) {
				getSSOUsersList({ filter: props.filterArray, type: 'filter' }, 50, props.pageNo);
				getSSOUserListCnt({ filter: props.filterArray, type: 'filter' });
			}else{
				getUsersList({ filter: props.filterArray, type: 'filter' }, 50, props.pageNo);
				getUserListCnt({ filter: props.filterArray, type: 'filter' });
			}

		} else {
			if (props.isApprovalPage) {
				getSSOUsersList(null, 50, parseInt(props.pageNo));
				getSSOUserListCnt(null);
			} else {
				getUsersList(null, 50, parseInt(props.pageNo));
				getUserListCnt(null);
			}
		}

		if (props.rowId) {
			getUserFormDetails();
		}
		if (props.isMailsent && contextValue.selectedRowIdInTable.length > 0) {
			sendEmailClicked(contextValue.selectedRowIdInTable);
		}

		
	}, [props.isMailsent, props.searchVal, props.searchVal.length, props.pageNo, props.saveUserDetails, props.editUserDetails, props.rowId, props.deleteUser, props.isFilter, props.filterArray]);

//separeate useeffect to avoid loading 
	useEffect(()=>{
		if (props.exportBtnClicked) {
			if(props.isApprovalPage) {
				getSSOExportData({ function: 'export', tenant: props.tenant });
			}else{
				getExportData({ function: 'export', tenant: props.tenant }, props.setExportDetails);
			}
		}
		if (props.isRefresh) {
			getUsersList(null, 50, parseInt(props.pageNo));
			getUserListCnt(null);
		}
	},[props.exportBtnClicked,props.isRefresh])

	const getSiteList = async () => {
		try {
			const { data, status } = await apiCall('/users/getSiteList');

			if (data && status === 'success') {
				console.log("getSiteList ====== >", data)
				console.log("getSiteList ====== >", typeof (data));
				props.setSiteList(data);
			}
		} catch (error) {
			console.error("getSiteList error :", error);

		}
	};

	const getRoles = async () => {
		const { data, status } = await apiCall('/users/getRoleList')
		try {
			if (data && status === 'success') {
				props.setRoleList(data);
				console.log("data is here", data)
			}

		} catch (error) {
			console.error("getRoles error :", error);

		}
	};

	const getUsersList = async (whereCondition: any, limit: Number, offset: Number) => {
		try {
			let { data, status } = await apiCall('/users/getUsers', { ...whereCondition, limit, offset })
			if (status === 'success') {
				props.func(data);
				props.setLoading(true);
			}
			console.log("apiData=", data);
		} catch (error) {
			console.error("An unexpected error occurred:", (error as Error).message);
			// Handle unexpected errors, log them, and potentially notify the user
		}
	};

	const getExportData = async (condition: object, setExportDetails: any) => {
		try {
			const { status, data } = await apiCall(`/users/getUsers`, condition);

			if (status === 'success' && data.length > 0) {
                props.exportBtnClicked && props.setExportDetails !== undefined && props.setExportDetails(data);
			} else {
				setExportDetails([]);
			}
		} catch (error) {
			console.log("remediation getExportData error=", error);
			setExportDetails([]);
		}
        props.setExportBtnClicked(false);
	}

	const getSSOExportData = async (condition: object) => {
		try {
			const { status, data } = await apiCall(`/users/getSSOUsers`, condition);

			if (status === 'success') {
				props.setExportDetails && props.setExportDetails(data);
			}
		} catch (error) {
			console.log("getExportData error=", error);
		}
		props.setExportBtnClicked(false);
	}

	const getUserListCnt = async (whereCondition: any) => {
		try {
			let { data, status } = await apiCall('/users/getUsersCount', whereCondition)

			if (status === 'success' && data.totalRecords > 0) {
				props?.setTotalRecords(data.totalRecords);
				props?.setTotalPages(data.totalPages);
			}
		} catch (error) {
			console.error("An unexpected error occurred:", error);
			// Handle unexpected errors, log them, and potentially notify the user
		}
	};

	const getUserFormDetails = async () => {
		const userId = props.rowId;
		console.log("userId", typeof (userId));
		try {
			let { data, status } = await apiCall('/users/getUserFormDetails', { userId });
			console.log("getUsersDetails", data);
			if (status === 'success' && data) {
				props.handleEditData([data]);
				props.setSpinnerLoad(false)
			} else {
				console.log("No data found");
				props.handleEditData([]);
			}
		} catch (error) {
			console.error("An unexpected error occurred:", (error as Error).message);
			props.handleEditData([]);
		}
	}

	const addUser = async () => {
		console.log(' props.formDataUser : ', props.formDataUser);
		const { firstName, lastName, emailid: userEmail, TimeZone: timeZone, Security: securityType, role: role_assigned, Tenant: tenant } = props.formDataUser || {};
		const formDataEdit = JSON.stringify(props.formDataUser) ?? null;
		const Created_on = JSON.stringify(Math.floor(Date.now() / 1000));
		const userType = props.saveUserDetails ? 'Local' : 'SSO';

		try {
			// Check if user already exists in the database
			const { data, status } = await apiCall('/users/checkUserDetails', {
				"user_email": userEmail
			});

			if (data?.length > 0) {
				console.log('User already exists');
				props.setEmailExistsToast(true)
				return false; // Early return if user exists
			} else {
				console.log('new user!!!');
			}
			// Add new user details to the database
			const { data: addUserData, status: addUserStatus } = await apiCall('/users/addUsersDetails', {
				firstName, lastName, userEmail, timeZone, securityType, formDataEdit, Created_on, userType, role_assigned, tenant, currentTenant
			});

			if (addUserStatus === 'success' && addUserData) {
				// Reset user details after successful addition
				props.setSaveUserDetails(false);
				props.setFormDataUser(null);
				// getUsersList(null, 50, parseInt(props.pageNo));
				// getUserListCnt(null);

				// Proceed to create user in the authentication system
				const accessToken = await Session.getAccessToken();
				const response = await apiCall('/users/createUser', {
					"email": userEmail,
					"role": role_assigned,
					"security": securityType
				}, "POST");
				console.log('response create user: ', response)
				if (response?.result === "Success") {
					console.log("API data for creating NEW user called", response.data);
					props.setOverlayOpen(false);
					props.setIsToast(true);
					props.setFormDataUser(null);


					return true;
				} else {
					console.error("Failed to create user in authentication system");
					return false;
				}
			} else {
				console.error("Failed to add user to the database");
				return false;
			}
		} catch (error: any) {
			console.error("An unexpected error occurred:", error.message);
			return false;
		}
	};

	const updateUserDetails = async () => {
		console.log('user prop ---->', props)

		// const {rowId, firstName, lastName, emailid: userEmail, TimeZone: timeZone, Security: securityType, role: role_assigned, Tenant: tenant } = props.formDataUser || {};
		// const formDataEdit = JSON.stringify(props.formDataUser) ?? null;
		// const modifiedOn = JSON.stringify(Math.floor(Date.now() / 1000));
		const rowId = props.rowId ?? null
		const firstName = props.formDataUser?.firstName ?? null
		const lastName = props.formDataUser?.lastName ?? null
		const userEmail = props.formDataUser?.emailid ?? null
		const timezone = props.formDataUser?.TimeZone ?? null
		const securityType = props.formDataUser?.Security ?? null
		const formDataEdit = JSON.stringify(props.formDataUser) ?? null
		const role_assigned = props.formDataUser?.role ?? null
		const tenant = props.formDataUser?.Tenant ?? null
		const modifiedOn = JSON.stringify(Math.floor(Date.now() / 1000));
		console.log('formData ------------>', formDataEdit);
		console.log('currentSelectedUserFormDetails.role ===========>', props.currentSelectedUserFormDetails.role);
		console.log('currentSelectedUserFormDetails.securityType ===========>', props.currentSelectedUserFormDetails.Security);
		let userDetails;
		let dataToSend = {
			rowId: rowId,
			firstName: firstName,
			lastName: lastName,
			userEmail: userEmail,
			timeZone: timezone,
			securityType: securityType,
			formDataEdit: formDataEdit,
			role_assigned: role_assigned,
			tenant: tenant,
			modifiedOn: modifiedOn,
			currentTenant: currentTenant
		}
		try {
			let { data } = await apiCall('/users/updateUserDetails', dataToSend);

			if (data.status == "Success") {
				console.log("rows affected for Updated Users from db:", data);
			}
			// return data;
		} catch (error) {
			console.error("An unexpected error occurred:", (error as Error).message);
			// Handle unexpected errors, log them, and potentially notify the user
		}
		if(props.isApprovalPage){
			const user_email = userEmail;
			
			const apiResponse = await apiCall('/users/getUsersDetails', { user_email });
			const data = apiResponse?.data;

			console.log(" getUsersDetails api Data= ", data);

			if (data?.length > 0) {
			  userDetails = data[0];
			  if(userDetails?.userStatus === "0"){
				console.log('getting user details', userDetails);
				sendMail(user_email, "ApprovedUserAccess");
			  }else{
				console.log('not getting user details', userDetails);
			  }
			}
		}
		if (securityType != props.currentSelectedUserFormDetails?.Security && securityType !== null) {
			try {
				// Send a POST request with the new role as JSON
				let response = await apiCall('/users/updateUserMetadata', {
					"email": userEmail,
					"security": securityType
				},
					"POST"
				);
				console.log("responce", response);
				if (response && response.status === 'Success') {
					// If the response is successful, parse and return the success message
					console.log("updateUserMetadata :", userEmail)
					const data = await response.json();
					return { success: 'Success', message: data.message };
				}
			} catch (error) {
				console.error("Error during fetch:", error);
				console.log("Error during fetch:");
				return { success: false, error: "Unexpected error occurred" };
			}
		} else {
			console.log('security is the same no update needed!')
		}

		console.log('props.currentSelectedUserFormDetails : ', props.currentSelectedUserFormDetails);
		console.log('role_assigned : ', role_assigned);
		if (props.currentSelectedUserFormDetails?.role !== role_assigned && role_assigned !== null) {
			try {
				// Send a POST request with the new role as JSON
				let response = await apiCall('/users/updateUserRole', {
					"role": role_assigned,
					"email": userEmail,
					"prevRole": props.currentSelectedUserFormDetails?.role
				},
					"POST"
				);

				if (response && response.status === 'Success') {
					// If the response is successful, parse and return the success message
					console.log("Adding new role")
					const data = await response.json();
					return { success: 'success', message: data.message };
				}

			} catch (error) {
				// Catch network or unexpected errors
				console.error("Error during fetch:", error);
				console.log("Error during fetch:");
				return { success: false, error: "Unexpected error occurred" };
			}
		} else {
			console.log('same role, no update neended')
		}
		if(props.isApprovalPage){
			const resp:any =  await updateUserStatus(userEmail);
			console.log('update user status response:', resp);
		}
	}

	const deleteUser = async (userid: any) => {
		{
			await userid.map(async (item: any) => {
				let userEmail = ''
				let userIdSuperToken = ''
				const userid = item
				console.log('userid to delete: ', userid);
				try {
					let { data } = await apiCall('/users/getUserEmail', { userid: userid });
					if (data && data.length > 0) {
						userEmail = data[0]?.user_email
					} else {
						return false
					}
				} catch (error) {
					console.error("An unexpected error occurred:", (error as Error).message);
					// Handle unexpected errors, log them, and potentially notify the user
				}

				//2. getting the userid through API CALL from supertokendb

				try {
					console.log("before getting id")
					let data = await apiCall('/users/getUserId', { userEmail }, "POST");
					console.log("checking getUserId ", data)
					if (data) {
						// const responseData = await data.json();
						// // Process the response data
						// userIdSuperToken = responseData.userid;

						//accessing userid directly without using json()
						userIdSuperToken = data.userid;
					} else {
						console.error("ERROR EMAIL:", data.status, data.statusText);

					}
				} catch (error) {
					console.error("ERROR getUserId CATCH:", error);
				}
				//3 calling delete API to delete the particular user and all its related items based on userid
				try {
					console.log("before deleteing user")
					let { data } = await apiCall('/users/deleteUser', { userIdSuperToken }, "POST");
					console.log("delete user data", data)
					if (data) {
						console.log("User deleted successfully.");
					} else {
						console.error("Error: No data received from the API.");
					}
				} catch (error) {
					console.error(" DELETE USER ERROR:", error);

				}
			})
			//loop ends

			// deleting from core.users
			try {
				let { data } = await apiCall("/users/deleteUsersDetails", { userid });

				if (data) {
					props.setDeleteDisabled(true);
					setTimeout(() => {
						props.setdeleteUserToast(true);
					}, 2000);
					setTimeout(() => {
						props.setDeleteUser(false);
						props.setdeleteUserToast(false);
					}, 1000);
					contextValue.setSelectedRowIdInTable([]);// remove selected userid's from context
				}
			} catch (error) {
				console.error("An error occurred:", error);
			}
		}
	};

	const sendEmailClicked = async (userIds: any) => {
		// Iterate through the selected user IDs
		await Promise.all(userIds.map(async (item: any) => {
			let userEmail = '';
	
			// 1. Get the user's email from API
			try {
				console.log('Fetching email for userID: ', item);
				let { data } = await apiCall('/users/getUserEmail', { userid: item });
				
				if (data && data.length > 0) {
					userEmail = data[0]?.user_email;
				} else {
					console.error('No email found for user ID:', item);
					return;
				}
			} catch (error) {
				console.error("Error fetching user email:", (error as Error).message);
				return;
			}
	
			// 2. Send the password reset email
			try {
				console.log('Sending password reset email to:', userEmail);
	
				const response = await sendPasswordResetEmail({
					formFields: [{ id: 'email', value: String(userEmail) }],
				});
	
				if (response.status === 'FIELD_ERROR') {
					response.formFields.forEach((formField: any) => {
						if (formField.id === 'email') {
							// window.alert(formField.error);
						}
					});
				} else if (response.status === 'PASSWORD_RESET_NOT_ALLOWED') {
					// window.alert('Password reset not allowed. Please check conditions.');
				} else {
					// window.alert('Password reset link sent successfully.');
					props.setMailSentToast(true)
				}
			} catch (error) {
				console.error('Error sending password reset email:', error);
			}
		}));
		// Optional: Any final UI updates after processing all users
		props.setMailSent(false);
	};
	

	const getSSOUsersList = async (whereCondition: any, limit: Number, offset: Number) => {
		try {
			let { data, status } = await apiCall('/users/getSSOUsers', { ...whereCondition, limit, offset })
			if (status === 'success') {
				props.func(data);
				props.setLoading(true);
			}
			console.log("apiData=", data);
		} catch (error) {
			console.error("An unexpected error occurred:", (error as Error).message);
			// Handle unexpected errors, log them, and potentially notify the user
		}
	};

	const getSSOUserListCnt = async (whereCondition: any) => {
		try {
			let { data, status } = await apiCall('/users/getSSOUsersCount', whereCondition)

			if (status === 'success' && data.totalRecords > 0) {
				props?.setTotalRecords(data.totalRecords);
				props?.setTotalPages(data.totalPages);
			}
		} catch (error) {
			console.error("An unexpected error occurred:", error);
			// Handle unexpected errors, log them, and potentially notify the user
		}
	};

	return (
		<></>
	)
}